import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import CurrencyItem from '../../../../components/CurrencyItem';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { topUpCardSlice } from '../../../../store/slices';

import './TopUpCardAsset.scss';

const { routes } = AppConfig;

const TopUpCardAsset = () => {
	const [card, setCard] = useState();

	const cardsList = useSelector(state => state.card.cardsList);

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const assets = card?.Addresses.map(address => ({
		Id: address.CurrencyId,
		Amount: address.Amount,
		AmountUsd: address.AmountUsd,
	}));

	useEffect(() => {
		const cardId = Number(searchParams.get('cardId'));
		setCard(cardsList.find(card => card.Id === cardId));
		dispatch(topUpCardSlice.actions.setBaseCurrencyAddresses([]));
	}, []);

	const selectAsset = asset => {
		navigate({
			pathname: routes.topUpCardAccount,
			search: createSearchParams({ cardId: card.Id, assetId: asset.Id }).toString(),
		});
	};

	return (
		<div className='TopUpCardAsset'>
			<PageHeader header={'Select asset to top up'} />
			<div className='TopUpCardAsset__body FormBlock'>
				{assets &&
					assets.map((currency, index) => <CurrencyItem key={index} currency={currency} onClick={selectAsset} />)}
			</div>
		</div>
	);
};

export default TopUpCardAsset;
